class FixedBuyButton {
  constructor() {
    this.mainButton = document.querySelector('#ProductSubmitButton-main-product');
    this.fixedButton = document.querySelector('.fixed-buy-button button');
    this.fixedButtonContainer = document.querySelector('.fixed-buy-button');

    if (this.mainButton && this.fixedButton && window.innerWidth <= 991) {
      this.setupIntersectionObserver();
      this.setupButtonSync();
    }
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          this.fixedButtonContainer.classList.add('is-visible');
        } else {
          this.fixedButtonContainer.classList.remove('is-visible');
        }
      });
    }, options);

    observer.observe(this.mainButton);
  }

  setupButtonSync() {
    this.syncButtonStates();

    const observer = new MutationObserver(() => {
      this.syncButtonStates();
    });

    observer.observe(this.mainButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });

    this.fixedButton.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Fixed button clicked');

      const buttonText = this.fixedButton.querySelector('span')?.textContent;
      if (buttonText === 'SELECIONE O TAMANHO') {
        const target = document.querySelector('.model-colors');
        if (target) {
          console.log('Scrolling to target element');
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 150; // -100 for offset
          console.log('Target position:', targetPosition);

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          });
        }
        return;
      }

      console.log('Triggering main button click');
      this.mainButton.click();
    });
  }

  syncButtonStates() {
    // Only sync text content and loading state
    const mainButtonText = this.mainButton.querySelector('span')?.textContent;
    if (mainButtonText) {
      this.fixedButton.querySelector('span').textContent = mainButtonText;
    }

    const isLoading = this.mainButton.classList.contains('loading');
    if (isLoading) {
      this.fixedButton.classList.add('loading');
      this.fixedButton.querySelector('.loading__spinner')?.classList.remove('hidden');
    } else {
      this.fixedButton.classList.remove('loading');
      this.fixedButton.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  }
}

customElements.define(
  'fixed-buy-button',
  class extends HTMLElement {
    connectedCallback() {
      new FixedBuyButton();
    }
  }
);
